import dangerousGoodsWoodpackingAudio from "@/app/ui/assets/audio/dangerous_goods_woodpacking_notification.mp3";
import dangerousGoodsWoodpackingForeignAudio from "@/app/ui/assets/audio/dangerous_goods_woodpacking_notification_en.mp3";
import woodpackingForeignAudio from "@/app/ui/assets/audio/woodpacking_notification_en.mp3";
import { getScanFlags } from "@/domain/entities/ScanFlags";

export const getScanNotificationSound = (data: any, fallback = "success"): string => {
  const flags = getScanFlags(data);
  if (flags.isDangerousGoods && flags.isWoodpacking)
    return "dangerous_goods_woodpacking";
  if (flags.isDangerousGoods) return "dangerous_goods";
  if (flags.isWoodpacking) return "woodpacking";
  return fallback;
};

type FlagNotificationSound =
  | "dangerous_goods"
  | "woodpacking"
  | "dangerous_goods_woodpacking";

const foreignFlagAudioSources: Partial<
  Record<FlagNotificationSound, string>
> = {
  "dangerous_goods_woodpacking": dangerousGoodsWoodpackingForeignAudio,
  woodpacking: woodpackingForeignAudio
};

export const playNotification = (type = "success", accountIsForeign = false) => {
  let audio = null;
  switch (type) {
    case "success":
      audio = new Audio(
        require("@/app/ui/assets/audio/success_notification.wav")
      );
      break;
    case "duplicate":
      audio = new Audio(
        require("@/app/ui/assets/audio/duplicate_scan_notification.wav")
      );
      break;
    case "error":
      audio = new Audio(
        require("@/app/ui/assets/audio/error_notification.wav")
      );
      break;
    case "success_cargo":
      audio = new Audio(
        require("@/app/ui/assets/audio/success_notif_cargo.wav")
      );
      break;
    case "failed_cargo":
      audio = new Audio(
        require("@/app/ui/assets/audio/failed_notif_cargo.wav")
      );
      break;
    case "pod":
      audio = new Audio(
        require("@/app/ui/assets/audio/pod_notification.mp3")
      );
      break;
    case "rts":
      audio = new Audio(
        require("@/app/ui/assets/audio/rts_notification.mp3")
      );
      break;
    case "hal":
      audio = new Audio(
        require("@/app/ui/assets/audio/hal_notification.mp3")
      );
      break;
    case "urgent_delivery":
      audio = new Audio(
        require("@/app/ui/assets/audio/urgent_delivery_notification.mp3")
      );
      break;
    case "bongkar":
      audio = new Audio(
        require("@/app/ui/assets/audio/bongkar_notification.mp3")
      );
      break;
    case "misroute":
      audio = new Audio(
        require("@/app/ui/assets/audio/misroute_notification.mp3")
      );
      break;
    case "dangerous_goods_woodpacking":
      audio = new Audio(dangerousGoodsWoodpackingAudio);
      break;
    case "dangerous_goods":
      audio = new Audio(
        require("@/app/ui/assets/audio/dangerous_goods_notification.mp3")
      );
      break;
    case "woodpacking":
      audio = new Audio(
        require("@/app/ui/assets/audio/woodpacking_notification.mp3")
      );
      break;
    default:
      break;
  }

  if (!audio) return;
  const foreignAudioSource = accountIsForeign
    ? foreignFlagAudioSources[type as FlagNotificationSound]
    : undefined;
  if (foreignAudioSource) audio.src = foreignAudioSource;
  audio.volume = 1;
  audio.play();
  audio.remove();
};
